var PriceFormatter = {
    format: function (t) {
        if (!t) return "";
        var e = (t = String(t)).substr(0, t.length - 2),
            r = t.substr(t.length - 2),
            a = "";
        return (
            PriceFormatter.currencySignAtStart && (a = PriceFormatter.currencySign),
            e.length > 3 && ((e = (e = PriceFormatter.stringReverse(e)).replace(/(.{3})/g, "$1" + PriceFormatter.thousandsSeparator)), (e = PriceFormatter.stringReverse(e))),
            (a += e),
            PriceFormatter.showDecimals && (a += PriceFormatter.decimalSeparator + r),
            PriceFormatter.currencySignAtEnd && (a += PriceFormatter.currencySign),
            a
        );
    },
    stringReverse: function (t) {
        for (var e = "", r = t.length - 1; r >= 0; r--) e += t[r];
        return e;
    },
    showPrice: function (t, e, r) {
        PriceFormatter.showPriceByElement($(t), e, r);
    },
    showPriceByElement: function (t, e, r) {
        (e != r && "no" != PriceFormatter.showComparePrice) || (r = ""), t.find("span.price s").html(PriceFormatter.format(r)), t.find("span.price span").html(PriceFormatter.format(e));
    },
};
function openMobileMenu() {
    $("#mobile-menu").css("visibility", "visible"), $("#mobile-menu-overlay").css("opacity", "0.5"), $("#mobile-menu-content").css("transform", "translateX(0%)");
}
function closeMobileMenu() {
    setTimeout(function () {
        $("#mobile-menu").css("visibility", "hidden");
    }, 200),
        $("#mobile-menu-overlay").css("opacity", "0"),
        $("#mobile-menu-content").css("transform", "translateX(-100%)");
}
function toggleSubMobileMenu() {
    "true" == $(this).next().attr("data-open")
        ? ($(this).next().attr("data-open", "false"), $(this).next().hide(), $(this).find("svg").css("transform", "rotate(0deg)"))
        : ($(this).next().attr("data-open", "true"), $(this).next().show(), $(this).find("svg").css("transform", "rotate(90deg)"));
}
function showSubDesktopMenu() {
    $(this).find("ul").show();
}
function hideSubDesktopMenu() {
    $(this).find("ul").hide();
}
function openCartDrawer() {
    $(document).width() < 768 ? $("#cart-drawer .cart-drawer-content").css("width", "100%") : $("#cart-drawer .cart-drawer-content").css("width", "35%"),
        $("#cart-drawer").css("visibility", "visible"),
        $("#cart-drawer-overlay").css("opacity", "0.5"),
        $("#cart-drawer .cart-drawer-content").css("transform", "translateX(0%)");
}
function closeCartDrawer() {
    setTimeout(function () {
        $("#cart-drawer").css("visibility", "hidden");
    }, 200),
        $("#cart-drawer-overlay").css("opacity", "0"),
        $("#cart-drawer .cart-drawer-content").css("transform", "translateX(100%)");
}
function toggleFooterLinkList() {
    if (!($(document).width() >= 768)) {
        var t = $(this).next();
        "none" == t.css("display") ? ($(this).find("span:last-child").text("-"), t.show()) : ($(this).find("span:last-child").text("+"), t.hide());
    }
}
function showLoadingIndicator() {
    $("#loading-indicator").css("display", "flex");
}
function hideLoadingIndicator() {
    $("#loading-indicator").css("display", "none");
}
function handleProductPage(t) {
    t = t ? "#" + t + " " : "";
    var e = $(t + ".product-media-main").attr("data-thumbnails"),
        r = $(t + ".product-media-main").attr("data-mobile-vertical"),
        a = $(t + ".product-media-main").attr("data-mobile-full-width"),
        i = parseInt($(t + ".product-media-main").attr("data-space-between-thumbnails")),
        n = 10;
    i > 0 && (n = i);
    var o = { pagination: { el: t + ".product-media-main .swiper-pagination" }, slidesPerView: 1, spaceBetween: 0 };
    if (
        ("true" != a && (o.spaceBetween = n),
        "true" == e && (o.thumbs = { swiper: new Swiper(t + ".product-media-thumbnail", { slidesPerView: 5, spaceBetween: i, slideToClickedSlide: !0 }) }),
        "true" == r
            ? ((o.direction = "vertical"),
              (o.touchReleaseOnEdges = !0),
              (o.resistanceRatio = 0),
              (o.mousewheel = { releaseOnEdges: !0 }),
              (o.breakpoints = { 768: { direction: "horizontal", spaceBetween: n } }),
              $(t + ".product-media-main").height($(t + ".product-media-main").width()))
            : (o.breakpoints = { 768: { spaceBetween: n } }),
        (window.mainSwiper = new Swiper(t + ".product-media-main", o)),
        $(t + ".product-media-main img").click(function () {
            window.mainSwiper.slideNext();
        }),
        $(t + '.product-information-quantity button[name="minus"]').click(function () {
            if (!$("#product-information-cart-button").attr("disabled")) {
                var e = $(t + ".product-information-quantity-field"),
                    r = $(t + ".product-information-quantity-input"),
                    a = Math.max(1, parseInt(e.val()) - 1);
                r.text(a), e.val(a), 1 == a && $(t + '.product-information-quantity button[name="minus"] svg path').css("stroke", "var(--color-border)");
            }
        }),
        $(t + '.product-information-quantity button[name="plus"]').click(function () {
            if (!$("#product-information-cart-button").attr("disabled")) {
                var e = $(t + ".product-information-quantity-field"),
                    r = $(t + ".product-information-quantity-input"),
                    a = parseInt(e.val()) + 1;
                $(this)[0].hasAttribute("data-stock") && (a = Math.min(a, $(this).attr("data-stock"))), r.text(a), e.val(a), $(t + '.product-information-quantity button[name="minus"] svg path').css("stroke", "var(--color-text)");
            }
        }),
        $(t + ".product-variant-select").change(setupSelectedVariant),
        $(t + ".product-variant-radio").change(setupSelectedVariant),
        $(t + ".product-information-variant-picker-button-variant-option").click(function () {
            var e = $(this).find(".product-variant-radio");
            $(t + '.product-variant-radio[name="' + e.attr("name") + '"]').removeAttr("checked"), e.attr("checked", !0), setupSelectedVariant();
        }),
        $(t + ".product-information-variant-picker-button-box").click(function (t) {
            var e = $(this).find(".product-information-variant-picker-button-variants");
            if ("none" == e.css("display")) return e.css("display", "flex"), void $(this).find("svg").css("rotate", "90deg");
            ($(t.target).is(".product-information-variant-picker-button-variant label") || $(t.target).is(".product-information-variant-picker-button-variant label *")) &&
                (e.css("display", "none"), $(this).find("svg").css("rotate", "0deg"));
        }),
        setupSelectedVariant(),
        $("form").submit(function (t) {
            t.preventDefault(),
                $("#product-information-cart-button").attr("disabled") ||
                    (showLoadingIndicator(),
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        dataType: "json",
                        data: $(this).serialize(),
                        success: function (t) {
                            loadCartData(function (t) {
                                openCartDrawer(), createCartItems(t), hideLoadingIndicator();
                            });
                        },
                        error: function (t) {
                            hideLoadingIndicator(),
                                t && t.responseJSON && t.responseJSON.description ? alert(t.responseJSON.message + "\n\n" + t.responseJSON.description) : alert("Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.");
                        },
                    }));
        }),
        $(t + ".product-information-scroll-to-form").click(productScrollToCartButton),
        $("#sticky-add-to-cart").length > 0)
    ) {
        if (
            ($("#product-information-cart-button").length > 0 && ($("#sticky-add-to-cart").attr("style", $("#product-information-cart-button").attr("style")), $("#sticky-add-to-cart").html($("#product-information-cart-button").html())),
            "top" == $("#sticky-add-to-cart").attr("data-position"))
        ) {
            var c = 0;
            $("#shopify-section-header-menu").css("--header-position").includes("fixed") && window.screen.width > 767 && (c = $("#header").outerHeight()), $("#sticky-add-to-cart").css({ bottom: "initial", top: c });
        }
        $("#sticky-add-to-cart").click(function () {
            "scroll" == $(this).attr("data-action") ? productScrollToCartButton() : $("#product-information-cart-button").click();
        }),
            setTimeout(function () {
                var t = 0;
                $("#product-information-cart-button").length > 0 && (t = $("#product-information-cart-button").offset().top),
                    $(window).scroll(function () {
                        $(this).scrollTop() > t ? $("#sticky-add-to-cart").css("display", "flex") : $("#sticky-add-to-cart").hide();
                    });
            }, 100);
    }
}
function productScrollToCartButton() {
    var t = 0;
    $("#product-information-cart-button").length > 0 && (t = $("#product-information-cart-button").offset().top - window.screen.height / 2), $("html, body").animate({ scrollTop: t }, 500);
}
function setupSelectedVariant() {
    var t = [];
    $(".product-variant-select").each(function () {
        t.push({ key: "option" + (product.options.indexOf($(this).attr("name")) + 1), value: $(this).val() });
    }),
        $(".product-information-variant-picker-button-variant-option").removeClass("product-information-variant-picker-button-variant-option-checked"),
        $(".product-variant-radio:checked").each(function () {
            $(this).parent().addClass("product-information-variant-picker-button-variant-option-checked");
            var e = $(this).parents(".product-information-variant-picker-button-variant").find("label span:eq(1)");
            "true" == e.attr("data-color-swatch")
                ? (e.html($(this).val() + '<span class="color-swatch" style="background-color: ' + $(this).next().css("background-color") + ';"></span>'),
                  $(this)
                      .parents(".product-information-variant-picker-button-variant")
                      .find("label span:eq(0) div")
                      .html(": " + $(this).val()))
                : e.html($(this).val()),
                t.push({ key: "option" + (product.options.indexOf($(this).attr("name")) + 1), value: $(this).val() });
        });
    var e = product.variants.find(function (e) {
        return t.every(function (t) {
            return e[t.key] === t.value;
        });
    });
    if (
        ($('input[name="id"]').val(e.id),
        $("#product-information-cart-button").removeAttr("disabled"),
        $(".product-information-quantity").css("opacity", "1"),
        $("#product-information-cart-button span").text($("#product-information-cart-button").attr("data-text-normal")),
        variantStock.hasOwnProperty(e.id))
    ) {
        $('.product-information-quantity button[name="plus"]').attr("data-stock", variantStock[e.id]);
        var r = $(".product-information-quantity-field");
        (a = parseInt(r.val())) > variantStock[e.id] ? (a = variantStock[e.id]) : 0 == a && variantStock[e.id] > 0 && (a = 1),
            r.val(a),
            $(".product-information-quantity").each(function () {
                $(this).find(".product-information-quantity-input").text(a),
                    a < 2 ? $(this).find('button[name="minus"] svg path').css("stroke", "var(--color-border)") : $(this).find('button[name="minus"] svg path').css("stroke", "var(--color-text)"),
                    0 == a &&
                        ($("#product-information-cart-button").attr("disabled", !0),
                        $(".product-information-quantity").css("opacity", "0.4"),
                        $("#product-information-cart-button span").text($("#product-information-cart-button").attr("data-text-disabled")));
            }),
            0 == $(".product-information-quantity").length &&
                0 == a &&
                ($("#product-information-cart-button").attr("disabled", !0),
                $(".product-information-quantity").css("opacity", "0.4"),
                $("#product-information-cart-button span").text($("#product-information-cart-button").attr("data-text-disabled")));
    } else
        $('.product-information-quantity button[name="plus"]').removeAttr("data-stock"),
            $(".product-information-quantity").each(function () {
                var t = $(".product-information-quantity-field"),
                    e = parseInt(t.val());
                0 == e && ((e = 1), $(".product-information-quantity-input").text(e), t.val(e), $('button[name="minus"] svg path').css("stroke", "var(--color-border)"));
            });
    if (
        (PriceFormatter.showPrice(".product-information-price", e.price, e.compare_at_price),
        e.featured_image && e.featured_image.position && $(".variant-picker").data("selectVariantImage") && window.mainSwiper.slideTo(e.featured_image.position - 1),
        0 != $(".product-information-price-saved").length)
    )
        if ((e.compare_at_price > e.price ? $(".product-information-price-saved").show() : $(".product-information-price-saved").hide(), "percentage" == $(".product-information-price-saved").attr("data-type"))) {
            var a = (100 * (e.compare_at_price - e.price)) / e.compare_at_price;
            $(".product-information-price-saved span").html(Math.ceil(a) + "%");
        } else PriceFormatter.showPrice(".product-information-price-saved span", e.compare_at_price - e.price);
}
function initCart() {
    $(".cart-drawer-content").on("click", ".cart-drawer-item-quantity-minus", function () {
        var t = $(this).attr("data-line-index"),
            e = $("#cart-drawer-item-quantity-input-" + t);
        e.val(parseInt(e.val()) - 1), updateCartItemQuantity(t, e.val());
    }),
        $(".cart-drawer-content").on("click", ".cart-drawer-item-quantity-plus", function () {
            var t = $(this).attr("data-line-index"),
                e = $("#cart-drawer-item-quantity-input-" + t),
                r = parseInt(e.val()) + 1;
            ($(this)[0].hasAttribute("data-stock") && r > parseInt($(this).attr("data-stock"))) || (e.val(r), updateCartItemQuantity(t, e.val()));
        }),
        $(".cart-drawer-content").on("click", ".cart-drawer-item-remove", function () {
            updateCartItemQuantity($(this).attr("data-line-index"), 0);
        });
}
function updateCartItemQuantity(t, e) {
    showLoadingIndicator(),
        $.ajax({
            type: "POST",
            url: "/cart/change",
            dataType: "json",
            data: { line: t, quantity: e },
            success: function () {
                loadCartData(function (t) {
                    createCartItems(t), hideLoadingIndicator();
                });
            },
            error: function () {
                alert("Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.");
            },
        });
}
function loadCartData(t) {
    $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (e) {
            t && t(e);
        },
        error: function () {
            alert("Es ist ein Fehler aufgetreten. Bitte versuches es noch einmal.");
        },
    });
}
function createCartItems(t) {
    var e = 0;
    if (!t || !t.items || 0 == t.items.length)
        return $(".cart-drawer-empty").show(), $(".cart-drawer-contents").hide(), $(".cart-drawer-footer").hide(), $("#header-cart-drawer-item-count").text(e), void $("#header-cart-drawer-item-count").hide();
    $(".cart-drawer-empty").hide(),
        $(".cart-drawer-contents").show(),
        $(".cart-drawer-footer").show(),
        $(".cart-drawer-item").not(".cart-drawer-item-temp").remove(),
        $(".cart-drawer-items").each(function (r, a) {
            t.items.forEach(function (t, r) {
                var i = $(a).find(".cart-drawer-item-temp").clone();
                i.appendTo($(a)), i.removeClass("cart-drawer-item-temp"), i.show(), i.find(".cart-drawer-item-image").attr("src", t.image);
                var n = i.find(".cart-drawer-item-data");
                if ((n.find("h3").text(t.product_title), !t.product_has_only_default_variant)) {
                    var o = n.find(".cart-drawer-item-options");
                    t.options_with_values.forEach(function (t) {
                        o.append('<div class="cart-drawer-item-option"><span>' + t.name + ":</span> " + t.value + "</div>");
                    });
                }
                if (t.properties && Object.keys(t.properties).length > 0) {
                    var c = n.find(".cart-drawer-item-properties");
                    for (var s in t.properties)
                        if (t.properties.hasOwnProperty(s)) {
                            var d = t.properties[s];
                            if (-1 !== d.indexOf("/uploads/")) {
                                var u = d.split("/");
                                d = '<a href="' + d + '" target="_blank">' + u[u.length - 1] + "</a>";
                            }
                            c.append('<div class="cart-drawer-item-option"><span>' + s + ":</span> " + d + "</div>");
                        }
                }
                var l = product.variants.find((e) => e.id == t.variant_id);
                l && l.compare_at_price != t.final_line_price
                    ? PriceFormatter.showPriceByElement(n.find(".cart-drawer-item-price"), t.final_line_price, l.compare_at_price)
                    : PriceFormatter.showPriceByElement(n.find(".cart-drawer-item-price"), t.original_line_price),
                    n.find(".cart-drawer-item-quantity-minus").attr("data-line-index", r + 1),
                    n.find(".cart-drawer-item-quantity-plus").attr("data-line-index", r + 1),
                    n.find(".cart-drawer-item-remove").attr("data-line-index", r + 1),
                    n.find(".cart-drawer-item-quantity input").attr("id", "cart-drawer-item-quantity-input-" + String(r + 1)),
                    n.find(".cart-drawer-item-quantity input").val(t.quantity),
                    (e += t.quantity);
            });
        }),
        PriceFormatter.showPrice(".cart-drawer-footer-subtotal", t.items_subtotal_price),
        PriceFormatter.showPrice(".cart-drawer-footer-total", t.total_price),
        $("#header-cart-drawer-item-count").text(e),
        parseInt(e) > 0 ? ($("#header-cart-drawer-item-count").show(), $("#header-cart-drawer-item-count").removeClass("hide")) : $("#header-cart-drawer-item-count").hide();
}
function handleCollectionPage() {
    var t = 1,
        e = !0,
        r = !1;
    $(window).scroll(function () {
        e &&
            !r &&
            ($(window).scrollTop() + 1.3 * window.screen.height < $(".collection-product-grid").offset().top + $(".collection-product-grid").height() ||
                (t++,
                (r = !0),
                $(".collection-product-grid-loading").show(),
                $.ajax({
                    url: "?page=" + t,
                    success: function (t) {
                        if (($(".collection-product-grid-loading").hide(), (r = !1), t)) {
                            var a = $(t);
                            a.find(".card-product").length > 0 ? $(".collection-product-grid-cards").append(a.find(".collection-product-grid-cards").html()) : (e = !1);
                        }
                    },
                    error: function () {
                        $(".collection-product-grid-loading").hide(), (r = !1);
                    },
                })));
    });
}
function handleSections(t) {
    (t = t ? "#" + t + " " : ""),
        $(t + ".collapsible-content-row-header").click(function () {
            $(this).find("svg").css("rotate", "90deg"),
                $(this).find("h3 span:last-child").text("-"),
                $(this).next().toggle(),
                "none" == $(this).next().css("display") && ($(this).find("svg").css("rotate", "0deg"), $(this).find("h3 span:last-child").text("+"));
        }),
        $(t + ".section-collection-cards").each(function () {
            if ("true" != $(this).attr("data-use-slider")) return !0;
            var t = { slidesPerView: 1.5, spaceBetween: 20, grabCursor: !0, breakpoints: { 768: { slidesPerView: 3.5 } } };
            "true" == $(this).attr("data-show-navigation") && "true" == $(this).attr("data-use-slider") && (t.navigation = { nextEl: $(this).find(".swiper-button-next")[0], prevEl: $(this).find(".swiper-button-prev")[0] }),
                new Swiper($(this)[0], t);
        }),
        new Swiper(t + ".custom-reviews-cards", {
            loop: !0,
            navigation: { nextEl: t + ".custom-reviews-cards .swiper-button-next", prevEl: t + ".custom-reviews-cards .swiper-button-prev" },
            breakpoints: { 768: { slidesPerView: 3, spaceBetween: 20 } },
        }),
        $(t + ".video-banner").each(function () {
            0 != $(this).find("video").length && videoBannerVideoLoaded($(this), $(this).find("video"));
        }),
        $(t + ".selling-point-slider").each(function () {
            new Swiper($(this)[0], {
                slidesPerView: 1,
                centeredSlides: !0,
                loop: !0,
                autoplay: { delay: 1e3 * parseInt($(this).attr("data-slideshow-speed")), disableOnInteraction: !1 },
                breakpoints: { 768: { centeredSlides: !1, slidesPerView: parseInt($(this).attr("data-desktop-slides-per-view")) } },
            });
        });
}
function videoBannerVideoLoaded(t, e) {
    4 == e[0].readyState
        ? t.css("padding-bottom", (e.height() / e.width()) * 100 + "%")
        : setTimeout(function () {
              videoBannerVideoLoaded(t, e);
          }, 50);
}
$(document).ready(function () {
    PriceFormatter.showComparePrice = $.trim($("body").attr("data-show-compare-price"));
    var t = $.trim($("body").attr("data-price-pattern"));
    (PriceFormatter.pricePattern = t),
        (PriceFormatter.currencySignAtStart = 0 != t.indexOf("1")),
        (PriceFormatter.currencySignAtEnd = !PriceFormatter.currencySignAtStart),
        PriceFormatter.currencySignAtStart ? (PriceFormatter.currencySign = t.substr(0, t.indexOf(1))) : PriceFormatter.currencySignAtEnd && (PriceFormatter.currencySign = t.substr(t.indexOf(6) + 1).trim()),
        (PriceFormatter.thousandsSeparator = t.substring(t.indexOf(1) + 1, t.indexOf(2))),
        (PriceFormatter.showDecimals = -1 !== t.indexOf(6)),
        PriceFormatter.showDecimals ? (PriceFormatter.decimalSeparator = t.substring(t.indexOf(4) + 1, t.indexOf(5))) : (PriceFormatter.decimalSeparator = ""),
        "true" == $(".header-announcement-bar").attr("data-use-slideshow") &&
            new Swiper(".header-announcement-bar", { slidesPerView: 1, centeredSlides: !0, autoplay: { delay: 1e3 * parseInt($(".header-announcement-bar").attr("data-slideshow-speed")), disableOnInteraction: !1 } }),
        $("main").css("padding-top", $("#header").outerHeight()),
        $(".header-menu-mobile-menu").click(openMobileMenu),
        $(".mobile-menu-header-close-icon").click(closeMobileMenu),
        $("#mobile-menu-overlay").click(closeMobileMenu),
        $(".header-menu-logo img").clone().prependTo(".mobile-menu-header"),
        $(".mobile-menu-header img").css("height", "auto"),
        $(".mobile-menu-sub-link-list").prev().removeAttr("href"),
        $(".mobile-menu-sub-link-list").prev().click(toggleSubMobileMenu),
        $(".header-menu-sub-links").parent().hover(showSubDesktopMenu, hideSubDesktopMenu),
        $(".header-menu-cart-drawer").click(openCartDrawer),
        $(".cart-drawer-header-close-icon").click(closeCartDrawer),
        $("#cart-drawer-overlay").click(closeCartDrawer),
        initCart(),
        $(".footer-column-menu h2").click(toggleFooterLinkList),
        $(".template-product").length > 0 && handleProductPage(),
        $(".custom-product-section").length > 0 && handleProductPage(),
        $(".template-collection").length > 0 && handleCollectionPage(),
        handleSections(),
        document.addEventListener("shopify:section:load", function (t) {
            "cart-drawer" == t.detail.sectionId && openCartDrawer(), handleSections("shopify-section-" + t.detail.sectionId), handleProductPage("shopify-section-" + t.detail.sectionId), lCheck();
        });
});
